import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import redRoom from "../../assets/hotseat/loading-room-red.webp";
import greenRoom from "../../assets/hotseat/loading-room-green.webp";
import isotipo from "../../assets/hotseat/wargos-isotipo.svg";

const spin = keyframes`to { transform: rotate(360deg); }`;
const pulse = keyframes`
  0%, 80%, 100% { opacity: .25; transform: translateY(0); }
  40% { opacity: 1; transform: translateY(-3px); }
`;
const Overlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 2;
  overflow: hidden;
  pointer-events: none;
  background: #190e09;
  opacity: 1;
  transition: opacity 600ms ease;
  &[data-ready="true"] { opacity: 0; }
  .room {
    position: absolute; inset: 0; width: 100%; height: 100%;
    object-fit: cover; transform: scale(1.015);
    filter: blur(1.5px) saturate(.85);
  }
  .shade {
    position: absolute; inset: 0;
    background: radial-gradient(ellipse, #100b0894 10%, #080504d4 100%);
  }
  .content {
    position: absolute; inset: 0; display: flex; flex-direction: column;
    justify-content: center; align-items: center; text-align: center;
    padding: 24px; font-family: Arial, sans-serif;
  }
  .eyebrow { color: #f5d993; font-size: 12px; letter-spacing: .36em; margin-bottom: 22px; }
  .emblem {
    position: relative; width: clamp(82px, 9vw, 124px); aspect-ratio: 1;
    display: grid; place-items: center; margin-bottom: 23px;
  }
  .logo {
    width: 46%; aspect-ratio: 90 / 91; background: #f4ce72;
    mask: url(${isotipo}) center / contain no-repeat;
    -webkit-mask: url(${isotipo}) center / contain no-repeat;
  }
  .ring { position: absolute; inset: 0; border: 1px solid #e8bf613d; border-radius: 50%; }
  .ring::after {
    content: ''; position: absolute; inset: -1px; border-radius: 50%;
    border: 3px solid transparent; border-top-color: #ffe3a1; border-right-color: #cf982e;
    animation: ${spin} 1.5s linear infinite;
  }
  h1 {
    font-size: clamp(30px, 3.3vw, 52px); font-weight: 600; line-height: 1.1;
    margin: 0; letter-spacing: .015em; color: #fff0c8; text-shadow: 0 2px 16px #000;
  }
  .dots { display: inline-flex; width: 30px; gap: 4px; margin-left: 5px; }
  .dots i { width: 4px; height: 4px; border-radius: 50%; background: #ffda86; animation: ${pulse} 1.5s ease-in-out infinite; }
  .dots i:nth-child(2) { animation-delay: .18s; }
  .dots i:nth-child(3) { animation-delay: .36s; }
  p { margin: 13px 0 0; color: #e2d2b8; font-size: clamp(14px, 1.2vw, 18px); letter-spacing: .06em; }
  @media (prefers-reduced-motion: reduce) {
    transition: none;
    .ring::after, .dots i { animation: none; }
  }
`;

export default function HotSeatLoading({ ready = false, green = false, image, label = "HOT SEAT", description = "Preparando la sala" }) {
  const [visible, setVisible] = useState(true);
  // Si la sala vuelve a cargar, el overlay reaparece.
  if (!ready && !visible) setVisible(true);
  useEffect(() => {
    if (!ready) return;
    const timer = setTimeout(() => setVisible(false), 650);
    return () => clearTimeout(timer);
  }, [ready]);
  if (!visible) return null;
  return (
    <Overlay data-testid="hotseat-loading" data-ready={ready} aria-hidden={ready || undefined}>
      <img className="room" src={image || (green ? greenRoom : redRoom)} alt="" fetchPriority="high" />
      <div className="shade" />
      <div className="content" role="status" aria-live="polite">
        <div className="eyebrow">{label}</div>
        <div className="emblem" aria-hidden="true"><div className="ring" /><div className="logo" /></div>
        <h1>Cargando<span className="dots" aria-hidden="true"><i /><i /><i /></span></h1>
        <p>{description}</p>
      </div>
    </Overlay>
  );
}
